import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Company Profile
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type CompanyprofileParameters = CompanyprofileInitClosedParameters | CompanyprofileInitCreatedParameters;
export type CompanyprofileEvents = CompanyprofileInitClosedEvent | CompanyprofileInitCreatedEvent;

export interface CompanyprofileInitClosedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	step: string; // step in which user clicked exit, possible values: "name", "size", "trade"
}

export type CompanyprofileInitClosedParametersSpecific = Omit<
	CompanyprofileInitClosedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const companyprofileInitClosedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class CompanyprofileInitClosedEventBuilder {
	constructor(private specificParameters: CompanyprofileInitClosedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<CompanyprofileInitClosedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			CompanyprofileInitClosedParametersSpecific,
            CompanyprofileInitClosedParameters,
			(params: CompanyprofileInitClosedParameters) => CompanyprofileInitClosedEvent
		>(this.specificParameters, companyprofileInitClosedParametersGlobal, globalParams, (params) => new CompanyprofileInitClosedEvent(params));
	}
}

/**
 * A user closed the company initialization dialog without completing it.
 */
export class CompanyprofileInitClosedEvent extends CraftnoteEvent<CompanyprofileInitClosedParameters>{
  constructor(parameters: CompanyprofileInitClosedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "companyInit_exit_clicked"
		},
		{
			name: "iterable",
			eventName: "companyprofile_init_closed"
		},
	]);
  }
}
export interface CompanyprofileInitCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	lastAction?: string; // last action on 4th onboarding screen, possible values are "invited", "skipped" or send nothing if the screen was not reachable
	invitedMemberCount: number; // the number of members invited through onboarding invitation screen
}

export type CompanyprofileInitCreatedParametersSpecific = Omit<
	CompanyprofileInitCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const companyprofileInitCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class CompanyprofileInitCreatedEventBuilder {
	constructor(private specificParameters: CompanyprofileInitCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<CompanyprofileInitCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			CompanyprofileInitCreatedParametersSpecific,
            CompanyprofileInitCreatedParameters,
			(params: CompanyprofileInitCreatedParameters) => CompanyprofileInitCreatedEvent
		>(this.specificParameters, companyprofileInitCreatedParametersGlobal, globalParams, (params) => new CompanyprofileInitCreatedEvent(params));
	}
}

/**
 * A user completed the company initialization dialog.
 */
export class CompanyprofileInitCreatedEvent extends CraftnoteEvent<CompanyprofileInitCreatedParameters>{
  constructor(parameters: CompanyprofileInitCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "companyInit_tradeNext_clicked"
		},
		{
			name: "iterable",
			eventName: "companyprofile_init_created"
		},
	]);
  }
}
